var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            "panel-title": "Thông tin chung",
            "panel-subtitle": "Vui lòng điền đầy đủ thông tin",
            "panel-icon": "el-icon-document-add",
            visible: _vm.dialogVisible,
            width: "70%",
            title: `Thực đơn các tuần: ${_vm.className}`,
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "tab-infor-button" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "medium" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialogByButton(
                                "createTabAllClassMenu"
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-close" }),
                          _c("span", [_vm._v("Đóng")]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "createTabAllClassMenu",
              attrs: {
                "label-width": "140px",
                "label-position": "left",
                model: _vm.tabClassMenuViewDetail,
              },
            },
            [
              _c(
                "div",
                { staticClass: "table-content row-data" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        "highlight-current-row": "",
                        "header-cell-style": _vm.tableHeaderColor,
                        data: _vm.tabClassMenuViewDetail,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "weeknumber",
                          label: "Tuần",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "timeApplyWeek",
                          label: "Thời gian áp dụng",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "approve",
                          label: "Duyệt",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.listCheckContentday != null ||
                                scope.row.fileList != null
                                  ? _c("el-checkbox", {
                                      attrs: {
                                        disabled:
                                          _vm.getAppTypeUserLogin !== "plus",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleCheckBoxApprove(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.approve,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "approve", $$v)
                                        },
                                        expression: "scope.row.approve",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "listCheckContentday",
                          label: "Ngày có nội dung",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "contentClassMenu",
                          label: "Thực đơn dạng File,Ảnh",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.listFileOrPicture) +
                                    "\n              "
                                ),
                                _c("el-upload", {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    action: "",
                                    "on-remove": _vm.handleRemove,
                                    "before-remove": _vm.beforeRemove,
                                    "auto-upload": false,
                                    "on-change": _vm.handleChangeFile,
                                    multiple: "",
                                    limit: 5,
                                    "file-list": scope.row.fileList,
                                    "on-preview": _vm.handleFileRequest,
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm.checkPermission(["studentQuality_menu_update"]) &&
                      _vm.getAppTypeUserLogin === "plus"
                        ? _c("el-table-column", {
                            attrs: {
                              label: "Tác vụ",
                              align: "center",
                              width: "130",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEditViewDetail(
                                                scope.$index,
                                                scope.row,
                                                2
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Sửa nội dung\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              199818479
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("UpdateClassMenu", {
        ref: "UpdateClassMenu",
        attrs: { dialogVisible: _vm.showUpdateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseUpdateMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }